/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
import React, { useContext, useState } from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Col, Divider, Input, message, Row, Typography } from 'antd';
import { useMutation } from '@apollo/react-hooks';
import { CostingContext } from 'views/Costing/common/context/CostingContext';
import UPDATE_COSTING_MUTATION, {
  UpdateCostingData,
  UpdateCostingVars,
} from 'shared/graphql/mutation/updateCosting';
import formatCurrency from 'shared/utils/formatCurrency';
import { Button } from 'shared/components';
import { TextProfitColor } from 'views/Costing/common/components';
import { useHistory } from 'react-router-dom';
import { StyledModal } from './Styles';

const { Text } = Typography;
const { TextArea } = Input;
type ModalConfirmRejectEditProps = {
  visible: boolean;
  onCancel: () => void;
};

const ModalConfirmRejectEdit: React.FC<ModalConfirmRejectEditProps> = (props) => {
  const { onCancel, visible } = props;
  const history = useHistory();
  const [rejectRemark, setRejectRemark] = useState<string>('');
  const { selectedCostingDetail } = useContext(CostingContext);
  const { modalConfirmRejectEdit, costingId, backUrl } = selectedCostingDetail;
  const {
    costingNumber,
    numberRef,
    totalAfterDiscountCost,
    totalAfterDiscountSale,
    profit,
  } = modalConfirmRejectEdit;

  const closeModalHandler = () => {
    history.push(backUrl);
  };

  const [updateCosting, { loading }] = useMutation<UpdateCostingData, UpdateCostingVars>(
    UPDATE_COSTING_MUTATION,
    {
      update: (_cache, { data }) => {
        const { _id } = data!.updateCosting;
        if (_id) {
          message.success('ปฎิเสธคำร้องขอแก้ไขแล้ว');
          onCancel();
          closeModalHandler();
        }
      },
      onError: (err) => {
        message.error(err.message);
      },
      refetchQueries: () => ['Costing', 'CostingStatus', 'Costings'],
    },
  );

  const confirmReject = () => {
    updateCosting({
      variables: {
        _id: costingId,
        confirm_edit: false,
        edit_request_remark: rejectRemark,
      },
    });
  };

  return (
    <StyledModal
      className="custom-modal"
      title="คุณต้องการปฎิเสธคำร้องขอแก้ไขใช่หรือไม่?"
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="okButton"
          icon={<CloseCircleOutlined />}
          color="red--light"
          onClick={() => confirmReject()}
          loading={loading}
          disabled={rejectRemark === ''}
        >
          ใช่, ต้องการปฎิเสธ
        </Button>,
        <Button
          key="cancelButton"
          icon={<CloseCircleOutlined />}
          onClick={onCancel}
          disabled={loading}
        >
          ยกเลิก
        </Button>,
      ]}
      afterClose={() => setRejectRemark('')}
    >
      <Row>
        <Col span={4}>
          <Row>
            <Col span={24}>รหัสต้นทุน/ขาย</Col>
            <Col span={24}>
              <Text strong>{costingNumber}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>รหัสงานขนส่ง</Col>
            <Col span={24}>
              <Text strong>{numberRef}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>ต้นทุนก่อนภาษี</Col>
            <Col span={24}>
              <Text strong>{formatCurrency(totalAfterDiscountCost)}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>รายได้ก่อนภาษี</Col>
            <Col span={24}>
              <Text strong>{formatCurrency(totalAfterDiscountSale)}</Text>
            </Col>
          </Row>
        </Col>
        <Col span={5}>
          <Row>
            <Col span={24}>กำไร - ขาดทุน</Col>
            <Col span={24}>
              <Text strong>
                <TextProfitColor value={profit} />
              </Text>
            </Col>
          </Row>
        </Col>
      </Row>

      <Divider style={{ marginTop: 10, marginBottom: 10 }} />

      <Row>
        <Col span={24}>
          เหตุผลการปฎิเสธ:<Text type="danger">*</Text>
        </Col>
        <Col span={24}>
          <TextArea
            value={rejectRemark}
            onChange={(event) => setRejectRemark(event.target.value)}
            placeholder="ระบุเหตุผล"
            rows={2}
          />
        </Col>
      </Row>
    </StyledModal>
  );
};

export default ModalConfirmRejectEdit;
